// FadeIn.js
import React, { useRef } from "react";
import { motion } from "framer-motion";
import fade from "../../keyframes/fade";
import "./FadeIn.css";
import { useInViewOnce } from "../../utils/animationUtils";

const FadeIn = ({ children, className = "", delay, ...props }) => {
    const ref = useRef(null);
    const inView = useInViewOnce(ref);


    return (
        <motion.div
            ref={ref}
            initial="hidden"
            animate={inView ? "visible" : "hidden"}
            exit="exit"
            variants={fade(delay)}
            className={className}
            {...props}
        >
            {children}
        </motion.div>
    );
};

export default FadeIn;
